import { Button, Stack, TextField, Typography } from "@mui/material";

export default function LlmProviderConnectionRow({
  provider,
  label,
  connected,
  value,
  onChange,
  onSave,
  onRevoke,
}) {
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Typography sx={{ width: 92 }}>{label}</Typography>
      <TextField
        size="small"
        type="password"
        value={value}
        placeholder={connected ? "Replace personal key" : "Paste API key"}
        slotProps={{ htmlInput: { "aria-label": `${label} API key` } }}
        onChange={(event) => onChange(provider, event.target.value)}
      />
      <Button size="small" onClick={() => onSave(provider)}>
        Save
      </Button>
      {connected ? (
        <Button size="small" color="error" onClick={() => onRevoke(provider)}>
          Revoke
        </Button>
      ) : null}
    </Stack>
  );
}
